const SESSION_FLAG = "IsSameSession";
const HEARTBEAT_KEY = "crmSessionHeartbeat";
const PENDING_NAV_KEY = "pendingNotificationTarget";
const HEARTBEAT_TTL_MS = 10 * 60 * 1000;

export const markSessionActive = () => {
  try {
    sessionStorage.setItem(SESSION_FLAG, "Yes");
    localStorage.setItem(HEARTBEAT_KEY, String(Date.now()));
  } catch {
    // ignore storage errors
  }
};

export const clearSessionMarkers = () => {
  try {
    sessionStorage.removeItem(SESSION_FLAG);
    localStorage.removeItem(HEARTBEAT_KEY);
    sessionStorage.removeItem(PENDING_NAV_KEY);
  } catch {
    // ignore storage errors
  }
};

export const isSessionExpired = () => {
  try {
    const raw = localStorage.getItem(HEARTBEAT_KEY);
    if (!raw) {
      return false;
    }
    const lastBeat = Number(raw);
    return lastBeat > 0 && Date.now() - lastBeat >= HEARTBEAT_TTL_MS;
  } catch {
    return false;
  }
};

export const hasLiveSession = () => !isSessionExpired();

export const isSameBrowserSession = () =>
  sessionStorage.getItem(SESSION_FLAG) === "Yes";

export const setPendingNotificationTarget = (path: string) => {
  try {
    sessionStorage.setItem(PENDING_NAV_KEY, path);
  } catch {
    // ignore storage errors
  }
};

export const consumePendingNotificationTarget = () => {
  try {
    const path = sessionStorage.getItem(PENDING_NAV_KEY);
    if (path) {
      sessionStorage.removeItem(PENDING_NAV_KEY);
    }
    return path;
  } catch {
    return null;
  }
};

export const getNotificationTargetPath = (notification: any): string | null => {
  const data =
    notification?.additionalData ||
    notification?.data ||
    notification?.notification?.additionalData ||
    {};

  const queryId =
    data.reference_id ||
    data.query_id ||
    data.queryId ||
    data.record_id ||
    data.query?.id;

  const reminderId = data.reminder_id;
  const type = `${data.notification_type || data.eventType || data.type || ""}`;

  if (queryId) {
    if (data.query_type === "amadeus" || data.is_amadeus) {
      return `/amadeus-query-detail/${queryId}`;
    }
    return `/query-detail/${queryId}`;
  }

  if (reminderId) {
    return `/reminders-details/${reminderId}`;
  }

  if (type.toLowerCase().includes("reminder")) {
    return "/reminders";
  }

  const rawUrl =
    notification?.launchURL ||
    notification?.url ||
    notification?.notification?.launchURL ||
    "";

  if (!rawUrl) {
    return null;
  }

  try {
    const parsed = new URL(rawUrl, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return null;
    }
    const path = `${parsed.pathname}${parsed.search}`;
    if (!path || path === "/" || path === "/login" || path === "/password-reset") {
      return null;
    }
    return path;
  } catch {
    return null;
  }
};
